import React from 'react';
import { useStrip } from '../hooks/useStrip';
import { useStripWindow } from '../hooks/useStripWindow';
import { Axis } from './Axis';

export const StripAxis: React.FC = () => {
  const tickInterval = 1_000; // ms
  const { xScale } = useStrip();
  const { start, end } = useStripWindow();
  const timeScale = xScale.copy().domain([start, end]);

  return (
    <Axis
      scale={timeScale}
      interval={tickInterval}
      formatter={(value) => `${parseInt(`${value}`, 10) / 1000}`}
    />
  );
};
